import { FlightSegmentStatus, SegmentWithTransferFragment } from '@websky/graphql';

export const hasCanceledSegment = (segments: SegmentWithTransferFragment[]) =>
	segments.some(({ segment }) => segment.status === FlightSegmentStatus.Canceled);
